import React from 'react';
import { Check, Wallet, ArrowDown } from 'lucide-react';
import { usePricing } from '@/contexts/PricingContext';

export function BtcBundleShowcase() {
  const pricing = usePricing();
  return (
    <div className="py-4">
      <p className="text-sm font-semibold mb-3 text-foreground" style={{ fontFamily: 'Poppins, sans-serif' }}>
        Included in your order
      </p>
      
      <div className="space-y-3">
        {/* What you get in the box */}
        <div className="rounded-2xl border border-gray-200 bg-white overflow-hidden">
          <div className="p-4">
            {/* Ryder One */}
            <div className="flex items-center gap-3 mb-3">
              <img 
                src="https://files.manuscdn.com/user_upload_by_module/session_file/310519663243023818/bfMrjDxrEMyxijvL.jpg"
                alt="Ryder One"
                className="w-14 h-14 object-cover rounded-lg border border-gray-100 flex-shrink-0"
                loading="lazy"
              />
              <div className="flex-1 min-w-0">
                <h5 className="text-sm font-bold text-foreground">Ryder One</h5>
                <p className="text-[11px] text-muted-foreground">Hardware wallet + EAL6+ security</p>
              </div>
              <div className="text-right shrink-0">
                <span className="text-sm font-bold text-foreground">${pricing.salePrice}</span>
                <span className="block text-[10px] text-muted-foreground line-through">${pricing.originalPrice}</span>
              </div>
            </div>
            {/* Free items inline */}
            <div className="flex flex-wrap gap-1.5 mt-2">
              {[
                { name: 'Recovery Tag', img: 'https://ryder.id/cdn/shop/files/recovery-tag.png?v=1770649962' },
                { name: 'Wireless Charger', img: 'https://ryder.id/cdn/shop/files/wireless_charging_1.png?v=1769270696' },
                { name: 'Travel Pouch' },
              ].map((item) => (
                <span key={item.name} className="inline-flex items-center gap-1.5 px-2 py-1 rounded-full bg-green-50 border border-green-100 text-[10px] font-medium text-green-700">
                  <Check className="w-3 h-3" />
                  {item.name} <span className="font-bold">FREE</span>
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Cashback indicator */}
        <div className="flex justify-center">
          <div className="w-8 h-8 rounded-full bg-[#6a63f5] flex items-center justify-center shadow-sm">
            <ArrowDown className="w-4 h-4 text-white" />
          </div>
        </div>

        {/* Bitcoin Cashback */}
        <div className="rounded-2xl border border-[#6a63f5]/20 bg-[#6a63f5]/[0.03] overflow-hidden">
          <div className="px-4 py-3 bg-[#6a63f5]/5 border-b border-[#6a63f5]/10">
            <div className="flex items-center gap-2">
              <Wallet className="w-4 h-4 text-[#6a63f5]" />
              <span className="text-xs font-semibold text-[#6a63f5] uppercase tracking-wider">Bitcoin Cashback</span>
            </div>
          </div>
          
          <div className="p-4 flex items-center gap-4">
            <div className="w-14 h-14 rounded-xl bg-[#6a63f5]/10 flex items-center justify-center flex-shrink-0">
              <span className="text-[#6a63f5] text-2xl font-bold">₿</span>
            </div>
            <div className="flex-1">
              <div className="text-xl font-bold text-foreground leading-none mb-1">$200 in Bitcoin</div>
              <p className="text-xs text-muted-foreground">Deposited to your Ryder wallet within 30 days of setup</p>
            </div>
          </div>
        </div>

        {/* Summary */}
        <div className="rounded-2xl bg-[#f8f7f4] border border-border/60 p-4 text-center">
          <div className="flex items-center justify-center gap-4 mb-1.5">
            <div className="text-center">
              <span className="text-[10px] text-muted-foreground uppercase tracking-wider block mb-0.5">You pay</span>
              <span className="text-base font-bold text-foreground">${pricing.salePrice}</span>
            </div>
            <span className="text-muted-foreground/40">→</span>
            <div className="text-center">
              <span className="text-[10px] text-muted-foreground uppercase tracking-wider block mb-0.5">You receive</span>
              <span className="text-base font-bold text-[#6a63f5]">$200 BTC</span>
            </div>
          </div>
          <p className="text-[11px] text-muted-foreground">Your wallet effectively pays for itself through the cashback program.</p>
        </div>
      </div>
    </div>
  );
}
